import { apiPaths, handleError, queryKeys, validateStatus } from './config'
import { useQueryApi } from 'utils/api'

import type { ResponseSkpPenilikPeriodDetail } from 'types/kinerja-penilik-pegawai'
import type { UseQueryOptions } from 'react-query'

export function useAPIGetPeriodDetail(
  id: string,
  options?: UseQueryOptions<ResponseSkpPenilikPeriodDetail>
) {
  return useQueryApi<ResponseSkpPenilikPeriodDetail>(
    `${apiPaths.getPeriod}/${id}`,
    {
      queryKey: [queryKeys.API_GET_PERIODE_DETAIL, id],
      axiosConfig: {
        validateStatus,
      },
      queryConfig: {
        useErrorBoundary: false,
        ...options,
      },
      errorHandlerFn: handleError,
    }
  )
}
